import { ReactNode } from 'react'

/**
 * Superficie para agrupar contenido. El kit no trae un panel genérico (su tarjeta es
 * la de programa académico), así que este vive en styles/app.css con las variables
 * de rol del kit (--dcc-surface, --dcc-border-subtle): sigue al tema oscuro solo.
 */
export function Panel({ titulo, acciones, children, className }: { titulo?: string; acciones?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={`panel${className ? ` ${className}` : ''}`}>
      {(titulo || acciones) && (
        <header className="panel__cabecera">
          {titulo && <h2 className="panel__titulo">{titulo}</h2>}
          {acciones && <div className="panel__acciones">{acciones}</div>}
        </header>
      )}
      {children}
    </section>
  )
}
